import View from "../../../Account/Js/views/NewslettersFiltersView";
import components from "./components.js";
components.define("js-NewslettersFilters", View);